/* @flow */

import type { RoleList } from './defs';
import { Roles } from './defs';

export const viewBrands: RoleList = [
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.ASSET_MANAGER,
  Roles.ACCOUNT_MANAGER,
];

export const viewAllBrands: RoleList = [
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.ASSET_MANAGER,
  Roles.ACCOUNT_MANAGER,
];

export const createBrands: RoleList = [Roles.SYSTEM_ADMIN, Roles.SYSTEM_ADMIN_REGIONAL];

export const updateBrands: RoleList = [Roles.SYSTEM_ADMIN, Roles.SYSTEM_ADMIN_REGIONAL];

export const restrictedRegionRoles: RoleList = [
  Roles.SYSTEM_ADMIN_REGIONAL,
  Roles.ASSET_MANAGER,
  Roles.ACCOUNT_MANAGER,
];

export const downloadBrands: RoleList = [...viewBrands];

export const downloadAccounts: RoleList = [...viewBrands];

export const downloadUsers: RoleList = [Roles.SYSTEM_ADMIN, Roles.SYSTEM_ADMIN_REGIONAL];
